import React from "react";
import "./App.css";
import "./index.css";

import { Routes, Route, Navigate } from "react-router-dom"; // Import Navigate for redirect
import NotFoundPage from "./components/404";
import LandingPage from "./section/landingPage";
import U1 from "./section/u1/index";
import PM from "./section/pm";
import OrderConfirmation from "./section/order-confirmation";
import Terms from "./section/documentations/terms";
import Contact from "./section/documentations/contact";
import Disclaimer from "./section/documentations/disclaimer";
import ReturnPage from "./section/documentations/return";
import Privacy from "./section/documentations/privacy";
import V5 from "./section/v5";
import VitalityBox from "./section/vitality-box";
import Fe from "./section/fe";

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Fe />} />
        <Route path="/u1" element={<U1 />} />
        <Route path="/pm" element={<PM />} />
        <Route path="/v5" element={<V5 />} />
        <Route path="/vitality-box" element={<VitalityBox />} />
        <Route path="/order-confirmation" element={<OrderConfirmation />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/disclaimer" element={<Disclaimer />} />
        <Route path="/returns" element={<ReturnPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </div>
  );
}

export default App;
